import { Label } from '@creanizer/ui'
import { Alert, AlertDescription } from '@creanizer/ui'
import { Info, Users } from 'lucide-react'
import type { CommunityInput, SavedCharacter } from '@creanizer/types'
import { generateCharacterContext } from '@creanizer/utils'

interface CharacterContextFormProps {
  input: CommunityInput
  onChange: (input: CommunityInput) => void
  characters?: SavedCharacter[]
}

export function CharacterContextForm({
  input,
  onChange,
  characters = [],
}: CharacterContextFormProps) {
  const handleCharacterSelect = (charIds: string[]) => {
    const selectedChars = characters.filter(c => charIds.includes(c.id))
    const contexts = selectedChars.map(char => generateCharacterContext(char))
    
    onChange({
      ...input,
      characterIds: charIds,
      characterContext: contexts.length > 0 ? contexts.join('\n\n') : undefined
    })
  }

  return (
    <div className="space-y-4">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          キャラクターの故郷、居住地、関連の深い土地としてコミュニティを生成します。
          選択されたキャラクターの背景や設定に適合した場所が作られます。
        </AlertDescription>
      </Alert>

      {characters.length > 0 ? (
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            <Label>関連キャラクター（複数選択可）</Label>
          </div>
          <div className="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto border rounded-md p-2">
            {characters.map((char) => (
              <label
                key={char.id}
                className="flex items-center space-x-2 p-2 border rounded cursor-pointer hover:bg-accent transition-colors"
              >
                <input
                  type="checkbox"
                  checked={input.characterIds?.includes(char.id) || false}
                  onChange={(e) => {
                    const ids = input.characterIds || []
                    const newIds = e.target.checked
                      ? [...ids, char.id]
                      : ids.filter(id => id !== char.id)
                    handleCharacterSelect(newIds)
                  }}
                  className="rounded"
                />
                <span className="text-sm truncate" title={char.title}>
                  {char.title}
                </span>
              </label>
            ))}
          </div>
          {input.characterIds && input.characterIds.length > 0 && (
            <p className="text-xs text-muted-foreground">
              選択中: {input.characterIds.length}名のキャラクター
            </p>
          )}
        </div>
      ) : (
        <Alert>
          <AlertDescription className="text-muted-foreground">
            保存済みのキャラクターがありません。
            キャラクタージェネレータでキャラクターを作成してから連携してください。
          </AlertDescription>
        </Alert>
      )}
    </div>
  )
}